export type QualityType =
  | 'WITH_PROTECTED_DESIGNATION_OF_ORIGIN_OEM'
  | 'WITH_PROTECTED_GEOGRAPHICAL_INDICATION_OFJ'
  | 'OTHER';

export const QualityType = {
  withProtectedDesignationOfOriginOem:
    'WITH_PROTECTED_DESIGNATION_OF_ORIGIN_OEM' as QualityType,
  withProtectedGeographicalIndicationOfj:
    'WITH_PROTECTED_GEOGRAPHICAL_INDICATION_OFJ' as QualityType,
  other: 'OTHER' as QualityType,
};
